export type PinPosition = 'top' | 'none' | 'bottom'

export interface NavigationSortItem {
  key: string
  pin_position?: PinPosition | string
  sort_order?: number
}

const PIN_RANK: Record<string, number> = { top: 0, none: 1, bottom: 2 }

function pinRank(pinPosition: string | undefined): number {
  return PIN_RANK[pinPosition ?? 'none'] ?? 1
}

export function sortSiblings<T extends NavigationSortItem>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const pinA = pinRank(a.pin_position)
    const pinB = pinRank(b.pin_position)
    if (pinA !== pinB) {
      return pinA - pinB
    }
    return (a.sort_order ?? 0) - (b.sort_order ?? 0)
  })
}

export function sortRootSections<T extends NavigationSortItem>(items: T[]): T[] {
  const admin = items.find((item) => item.key === 'admin')
  const rest = items.filter((item) => item.key !== 'admin')
  const sorted = sortSiblings(rest)
  return admin ? [...sorted, admin] : sorted
}
